module.exports = __webpack_public_path__ + "img/[捂脸].83a8b945.svg";